const styles = () => ({
  dialogContent: {
    paddingLeft: 0,
    paddingRight: 0,
  }
});

export default styles;